import React, { Component, Fragment } from 'react';
import Breadcrumb from '../common/breadcrumb';
import AuthService from '../services/auth.service';
import ApiService from '../services/api.service';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const COHORT_OPTIONS = [
    { value: 30, label: 'Últimos 30 días' },
    { value: 60, label: 'Últimos 60 días' },
    { value: 120, label: 'Últimos 120 días' },
    { value: 180, label: 'Últimos 180 días' },
    { value: 365, label: 'Último año' },
];

export class Ver_create_bulk_whatsapp_campaign extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            message_body: '',
            cohort_days: 30,
            loading: false,
        };
        this.handleSave = this.handleSave.bind(this);
    }

    handleSave(e) {
        e.preventDefault();

        const { name, message_body, cohort_days } = this.state;

        if (!name.trim()) {
            toast.error('El nombre de la campaña es obligatorio');
            return;
        }
        if (!message_body.trim()) {
            toast.error('El mensaje es obligatorio');
            return;
        }

        this.setState({ loading: true });
        const user = AuthService.getCurrentUser();

        ApiService.postBulkWhatsappCampaign(user.token, {
            name: name.trim(),
            message_body: message_body.trim(),
            cohort_days: parseInt(cohort_days),
        }).then(
            (res) => {
                if (res && res.status === 'success') {
                    toast.success('Campaña creada exitosamente');
                    setTimeout(() => {
                        this.props.history.push('/bulk-whatsapp-campaigns');
                    }, 1000);
                } else {
                    toast.error((res && res.message) || 'Error al crear la campaña');
                    this.setState({ loading: false });
                }
            },
            (error) => {
                const msg =
                    (error.response && error.response.data && error.response.data.message) ||
                    error.message ||
                    error.toString();
                toast.error(msg);
                this.setState({ loading: false });
            }
        );
    }

    render() {
        const { name, message_body, cohort_days, loading } = this.state;
        return (
            <Fragment>
                <Breadcrumb title="Nueva Campaña WhatsApp Masiva" parent="Promociones" />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card">
                                <div className="card-header">
                                    <h5>Crear Campaña WhatsApp Masiva</h5>
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.handleSave}>
                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4">
                                                <span>*</span> Nombre de la Campaña
                                            </label>
                                            <div className="col-md-7">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Ej: Campaña Verano 2025"
                                                    value={name}
                                                    onChange={(e) => this.setState({ name: e.target.value })}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4">
                                                <span>*</span> Cohort de Clientes
                                            </label>
                                            <div className="col-md-7">
                                                <select
                                                    className="form-control"
                                                    value={cohort_days}
                                                    onChange={(e) => this.setState({ cohort_days: e.target.value })}
                                                >
                                                    {COHORT_OPTIONS.map((o) => (
                                                        <option key={o.value} value={o.value}>
                                                            {o.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                <small className="form-text text-muted">
                                                    Clientes que hayan comprado en ese rango de tiempo.
                                                </small>
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label className="col-xl-3 col-md-4">
                                                <span>*</span> Mensaje de WhatsApp
                                            </label>
                                            <div className="col-md-7">
                                                <textarea
                                                    className="form-control"
                                                    rows="5"
                                                    placeholder="Ej: Hola {nombre}, ¡tenemos una oferta especial para ti!"
                                                    value={message_body}
                                                    onChange={(e) => this.setState({ message_body: e.target.value })}
                                                    required
                                                />
                                                <small className="form-text text-muted">
                                                    Usa <code>{'{nombre}'}</code> para personalizar con el nombre del cliente.
                                                </small>
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <div className="col-md-7 offset-xl-3 offset-md-4">
                                                <div
                                                    className="card"
                                                    style={{
                                                        backgroundColor: '#e5ddd5',
                                                        borderRadius: '8px',
                                                        padding: '15px',
                                                    }}
                                                >
                                                    <small className="text-muted mb-2">
                                                        <strong>Vista previa del mensaje:</strong>
                                                    </small>
                                                    <div
                                                        style={{
                                                            backgroundColor: 'white',
                                                            padding: '12px',
                                                            borderRadius: '8px',
                                                            whiteSpace: 'pre-wrap',
                                                            wordBreak: 'break-word',
                                                            boxShadow: '0 1px 2px rgba(0,0,0,0.1)',
                                                        }}
                                                    >
                                                        {message_body.replace(/\{nombre\}/gi, 'Juan') || (
                                                            <span className="text-muted">El mensaje aparecerá aquí...</span>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="pull-right">
                                            <button
                                                type="button"
                                                className="btn btn-light mr-2"
                                                onClick={() => this.props.history.push('/bulk-whatsapp-campaigns')}
                                            >
                                                Cancelar
                                            </button>
                                            <button
                                                type="submit"
                                                className="btn btn-primary"
                                                disabled={loading}
                                            >
                                                {loading && (
                                                    <span className="spinner-border spinner-border-sm mr-1"></span>
                                                )}
                                                Guardar
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Fragment>
        );
    }
}

export default Ver_create_bulk_whatsapp_campaign;
